import { Component, OnInit, Input } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';

import { DataService } from '../../../../services/data.service';

@Component({
	selector: 'app-tipi-spedizioni',
	templateUrl: './tipi-spedizioni.component.html',
	styleUrls: ['./tipi-spedizioni.component.css']
})
export class TipiSpedizioniComponent implements OnInit {
	@Input() writePermission : boolean = false;
	tipiSpedizioneSync: Subscription;
	tipiSpedizione: any[] = [];

	nuovaSpedizione: any = {
		nome : '',
		descrizione : ''
	}

	spedizioneModificata: any = {
		id : '',
		nome : '',
		descrizione : ''
	}

	constructor(private dataService:DataService) { }

	ngOnInit() {
		this.tipiSpedizioneSync = this.dataService.tipiSpedizione$.subscribe(
			tipiSpedizione => {
				this.tipiSpedizione = tipiSpedizione;
				this.reset();
				console.log('TIPI SPEDIZIONE',this.tipiSpedizione);
			});
	}

	reset() {
		this.nuovaSpedizione.nome = '';
		this.nuovaSpedizione.descrizione = '';
		this.spedizioneModificata.id = '';
		this.spedizioneModificata.nome = '';
		this.spedizioneModificata.descrizione = '';
	}

	canAdd() {
		if (!this.writePermission) {
			return false;
		}
		else if (this.nuovaSpedizione.nome && this.nuovaSpedizione.descrizione) {
			return true;
		}
		else {
			return false;
		}
	}

	aggiungiSpedizione() {
		if (this.nuovaSpedizione.nome != '' && this.nuovaSpedizione.descrizione != '') {
			this.dataService.insert("tipi_spedizione", this.nuovaSpedizione, false, (error,res) => {
				if (error) {
					this.dataService.openMessage('INSERIMENTO TIPO SPEDIZIONE','si è verificato un errore');
				}
			});
		}
	}

	apriModificaSpedizione(spedizione: any) {
		this.spedizioneModificata.id = spedizione.id;
		this.spedizioneModificata.tipo = spedizione.nome;
		this.spedizioneModificata.descrizione = spedizione.descrizione;
	}

	salvaModificaSpedizione() {
		let localFilters = [];
		localFilters.push({ type: "=", key: "id", value: this.spedizioneModificata.id });

		this.dataService.update("tipi_spedizione", localFilters, this.spedizioneModificata, false, (error,res) => {
			if (error) {
				//this.dataService.openMessage('AGGIORNAMENTO TIPO SPEDIZIONE','si è verificato un errore');
			}
		});
	}

	annullaModificaSpedizione() {
		this.reset();
	}

	eliminaSpedizione(spedizione: any) {
		let localFilters = [];
		localFilters.push({ type: "=", key: "id", value: spedizione.id });

		this.dataService.delete("tipi_spedizione", localFilters, false, (error,res) => {
			if (error) {
				//this.dataService.openMessage('ELIMINAZIONE TIPO SPEDIZIONE','si è verificato un errore');
			}
		});
	}

	ngOnDestroy() {
		this.tipiSpedizioneSync.unsubscribe();
	}

}
